import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 23,
		height: 23,
		rx: "var(--radio-radius, 7.5)",
		fill: "var(--control-rest-bg, none)",
		stroke: "var(--control-rest-border, #869496)",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5.5,
		y: 5.5,
		width: 14,
		height: 14,
		rx: "var(--radio-dot-radius, 4)",
		fill: "var(--control-selected-bg, #79FBAF)"
	})]
});
export default SvgRadioSelected;
